import { Component, Vue } from 'vue-property-decorator';
import WithRender from './unapproved.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import { ApprovedType, UnApprovedType } from '@/types/deposit.type';

@WithRender
@Component({
    filters: {
        formateDate(value: string) {
            return moment(value).format('YYYY-MM-DD HH:mm A')
        }
    },
    components: {
        Loading,
    },
})
export default class UnApproved extends Vue {
    unApproved = {} as UnApprovedType;
    items = [];
    fields = [
        {
            key: "userName",
        },
        {
            key: "fullName",
        },
        {
            key: "reflectingInBank",
        },
        {
            key: "depositType",
        },
        {
            key: "reference",
        },
        {
            key: "comment",
        },
        {
            key: "createdOn",
            label: "Time",
        },
        {
            key: "amount",
        },
        {
            key: "id",
            label: ""
        },
        {
            key: "id2",
            label: ""
        }
    ]

    display = true;
    username = ""
    busy = false;
    reject = false;
    processing = false;
    approveDetails = "";
    instance = "";
    approve = {} as ApprovedType;

    onSubmit() {
        this.processing = false
        this.busy = true
    };

    onApproveClick(item: UnApprovedType) {
        this.approveDetails = `Approve for ${item.userName} Ref: ${item.reference} comment: ${item.comment} \n amount R${item.amount}`;
        this.approve.Id = item.id;
        this.reject = false;
        this.busy = true;
    }

    onRejectClick(item: UnApprovedType) {
        this.approveDetails = `Reject for ${item.userName} Ref: ${item.reference} comment: ${item.comment} \n amount R${item.amount}`;
        this.approve.Id = item.id;
        this.busy = true;
        this.reject = true;
    }

    onCancel() {
        this.busy = false
    };

    onOK() {
        this.processing = true;
        if (this.reject)
            this.onReject();
        else
        this.onApprove();
    }

    async mounted() {
        await this.loadUnApproved()
    }

    async onApprove() {
        try {
            await _axios.post(`${config.gateway}credits/deposit/Approve`, this.approve);
            await this.loadUnApproved()
            this.$bvToast.toast("Approval was successful", {
                title: 'Notification',
                variant: 'success',
                autoHideDelay: 5000,
            });
            this.busy = false;
            this.processing = false;
        } catch (error) {
            this.$bvToast.toast("Something went wrong whilst trying to approve", {
                title: 'Notification',
                variant: 'danger',
                autoHideDelay: 5000,
            });
            this.busy = false;
            this.processing = false;
        }
    }

    async onReject() {
        try {
            await _axios.post(`${config.gateway}credits/deposit/Reject`, this.approve);
            await this.loadUnApproved()
            this.$bvToast.toast("Reject was successful", {
                title: 'Notification',
                variant: 'success',
                autoHideDelay: 5000,
            });
            this.busy = false;
            this.processing = false;
        } catch (error) {
            this.$bvToast.toast("Something went wrong whilst trying to reject", {
                title: 'Notification',
                variant: 'danger',
                autoHideDelay: 5000,
            });
            this.busy = false;
            this.processing = false;
        }
    }

    private async loadUnApproved() {
        try {
            const response = await _axios.get(`${config.gateway}credits/deposit/UnApproved`);
            this.items = response.data;
        } catch (error) {
            console.log(error);
        }
    }
}